export class CountrySetting {
    country: string;
    region: string;
    countryCode: string;

    constructor(country: string, region: string, countryCode: string) {
        this.country = country;
        this.region = region;
        this.countryCode = countryCode;
    }
}
